import styled, { css } from 'styled-components';

import { getSpace } from '@yoweb/ui/styles/utils/theme';
import { pxToRem, media } from '@yoweb/ui/styles/utils';

export const Ol = styled.ol<{ isNumeric?: boolean }>`
  margin-left: ${pxToRem(20)};

  li {
    margin-top: ${getSpace('normal1')};
  }

  list-style: lower-alpha;

  ${({ isNumeric }) =>
    isNumeric &&
    css`
      list-style: decimal;

      ol {
        list-style: lower-alpha;
      }

      ol ol {
        list-style: lower-roman;
      }
    `}

  ol {
    list-style: lower-roman;
  }

  ol ol {
    list-style: decimal;
  }

  ${media.md`
    margin-left: ${pxToRem(40)};
  `}
`;
